import { Component, OnInit, signal, computed, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DashboardService } from '../../services/dashboard.service';
import { QuotaUsageAnalyticsDto, QuotaAnalyticsData } from '../../services/dashboard.interface';
import { QuotaAnimalsGridComponent } from '../../components/dashboard-charts/quota-animals-grid/quota-animals-grid';
import { AllocatedQuotasDonutComponent } from '../../components/dashboard-charts/allocated-quotas-donut/allocated-quotas-donut';
import { LatestApplicationsComponent } from '../../components/dashboard-charts/latest-applications/latest-applications';
import { QuotaDeadlinesBarsComponent } from '../../components/dashboard-charts/quota-deadlines-bars/quota-deadlines-bars';
import { SupplierTypeLimitsCompareComponent } from '../../components/dashboard-charts/supplier-type-limits-compare/supplier-type-limits-compare';
import { TopSuppliersDonutComponent } from '../../components/dashboard-charts/top-suppliers-donut/top-suppliers-donut';
import { UsagePercentageDonutComponent } from '../../components/dashboard-charts/usage-percentage-donut/usage-percentage-donut';

@Component({
  selector: 'app-dashboard',
  imports: [
    TranslateModule,
    QuotaAnimalsGridComponent,
    AllocatedQuotasDonutComponent,
    LatestApplicationsComponent,
    QuotaDeadlinesBarsComponent,
    SupplierTypeLimitsCompareComponent,
    TopSuppliersDonutComponent,
    UsagePercentageDonutComponent
  ],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class Dashboard implements OnInit {
  analyticsData = signal<QuotaAnalyticsData | null>(null);
  selectedCard = signal<QuotaUsageAnalyticsDto | null>(null);

  allCards = computed(() => {
    const data = this.analyticsData();
    if (!data) return [];

    
    const totalCard: QuotaUsageAnalyticsDto = {
      quotaId: 0,
      quotaComparePreviousMonth: data.quotaUsageAnalyticsTotalDto.quotaComparePreviousMonth,
      totalVolume: data.quotaUsageAnalyticsTotalDto.totalVolume,
      totalAllocated: data.quotaUsageAnalyticsTotalDto.totalAllocated,
      deliveredVolume: data.quotaUsageAnalyticsTotalDto.deliveredVolume,
      remainingVolume: data.quotaUsageAnalyticsTotalDto.remainingVolume,
      usagePercentage: data.quotaUsageAnalyticsTotalDto.usagePercentage,
      topNewSuppliers: data.quotaUsageAnalyticsTotalDto.topNewSuppliers,
      topHistoricalSuppliers: data.quotaUsageAnalyticsTotalDto.topHistoricalSuppliers,
      antiTopNewSuppliers: data.quotaUsageAnalyticsTotalDto.antiTopNewSuppliers,
      antiTopHistoricalSuppliers: data.quotaUsageAnalyticsTotalDto.antiTopHistoricalSuppliers,
      quotaNewSupplierTypeLimit: data.quotaUsageAnalyticsTotalDto.quotaNewSupplierTypeLimit,
      quotaHistoricalSupplierTypeLimit: data.quotaUsageAnalyticsTotalDto.quotaHistoricalSupplierTypeLimit,
      quotaDeadlines: data.quotaUsageAnalyticsTotalDto.quotaDeadlines,
      newApplications: data.quotaUsageAnalyticsTotalDto.newApplications,
      expiringApplications: data.quotaUsageAnalyticsTotalDto.expiringApplications,
      meatType: {
        id: 0,
        nameRu: 'Всем видам мяса',
        nameKy: 'Эттин бардык түрлөрү',
        alias: 'TOTAL'
      },
      title: data.quotaUsageAnalyticsTotalDto.title
    };

    // Возвращаем массив с totalCard первой, затем остальные
    return [totalCard, ...data.quotaUsageAnalyticsDtoList];
  });

  constructor(private dashboardService: DashboardService) {}

  ngOnInit(): void {
    const currentYear = new Date().getFullYear();
    this.dashboardService.getQuotaAnalytics(currentYear).subscribe({
      next: (response) => {
        if (response.success && response.res) {
          this.analyticsData.set(response.res);

         
          const cards = this.allCards();
          if (cards.length > 0) {
            this.selectedCard.set(cards[0]);
          }
        }
      },
      error: (error) => {
        console.error('Error loading analytics:', error);
      }
    });
  }

  onCardSelected(card: QuotaUsageAnalyticsDto | null): void {
    this.selectedCard.set(card);
  }
}
